import { TypePermissionEntity } from "@/data/default/types/enumPermission";
import { RouteConfig } from "vue-router";
import RouterDirector from "@/data/default/types/RouterDirector";

const builder = RouterDirector.makeRouterWithPermission({
  name: "legislacaoVigente",
  permissionEntity: TypePermissionEntity.LEGISLACAO_VIGENTE,
  componentRoot: () => import("@/screens/default/legislacaoVigente/Index.vue"),
  componentList: () => import("@/screens/default/legislacaoVigente/List.vue"),
  componentSave: () => import("@/screens/default/legislacaoVigente/Save.vue")
});

export const Router: RouteConfig[] = [builder.getRootRoute()];

export const routes = builder.getRouteNames();
